<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between align-center headline">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              Permutas
            </div>
            <div class="d-flex">
              <BtnCreateDataExport 
                class="mx-3"
                api_model="Exchange" 
                action="Exchanges"
                :filters="filters"
              ></BtnCreateDataExport>
              <v-btn text icon color="white" aria-label="Atualizar lista" @click="onHeaderRefreshExchanges">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text class="py-0">
            <router-view @doneFilter="handleDoneFilter"></router-view>
          </v-card-text>
        </v-card>
      </template>
    </index-card>
  </div>
</template>

<script>
export default {
  name: 'Exchanges',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
  },
  provide() {
    const vm = this
    return {
      registerExchangesListReload(fn) {
        vm.exchangesListReload = fn
      },
    }
  },
  data() {
    return {
      filters: {},
      exchangesListReload: null,
    }
  },
  methods: {
    handleDoneFilter(filter){
      this.filters = {...filter}
    },
    onHeaderRefreshExchanges() {
      if (this.exchangesListReload) this.exchangesListReload()
    },
  },
}
</script>
